import { useEffect, useRef, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { LogoutAsync, SelectIsLogged } from '../../features/authentication/authenticationSlice';

const INACTIVITY_LIMIT_MS = 20 * 60 * 1000;

export const useIdleTimer = () => {
    const dispatch = useAppDispatch();
    const isLogged = useAppSelector(SelectIsLogged);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const handleLogout = useCallback(() => {
        dispatch(LogoutAsync());
    }, [dispatch]);

    const resetTimer = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        if (isLogged) {
            timerRef.current = setTimeout(handleLogout, INACTIVITY_LIMIT_MS);
        }
    }, [isLogged, handleLogout]);

    useEffect(() => {
        if (!isLogged) {
            if (timerRef.current) clearTimeout(timerRef.current);
            return;
        }

        const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];

        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        resetTimer();

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [isLogged, resetTimer]);
};